import React from "react";
import {
  TagsField,
  TagsFieldProps,
} from "../../commons/form-fields/TagsField.js";
import { isTagReserved, useReservedTagLabels } from "./useReservedTagLabels.js";

export const CrmTagsField = (props: TagsFieldProps) => {
  const { reservedTagLabels } = useReservedTagLabels();

  const getTagLabel = (tag: string) => {
    return isTagReserved(tag) ? reservedTagLabels[tag] : tag;
  };

  return <TagsField {...props} getTagLabel={getTagLabel} />;
};
